// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.rounded-button {
    mix-blend-mode: normal;
    border: 2px solid var(--new-green-color);
    box-sizing: border-box;
    border-radius: var(--space-x2);
    padding: var(--space-quarter) var(--space) !important;
    color: var(--new-green-color);
    /* margin-left: var(--space); */
}
.rounded-button:focus {
    background-color: var(--focused-rb-bg-color);
}
.rounded-button:hover {
    background-color: var(--hover-rb-bg-color);
}
.rounded-button:active {
    background-color: var(--active-rb-bg-color);
}
.rounded-button:disabled {
    color: var(--disabled-rb-font-color);
    border: 2px solid var(--primary-light-color);
    background-color: var(--disabled-rb-bg-color) !important;    
}

/* .rounded-button span{
    text-transform: capitalize;
} */

.rounded-button.inverse {
    mix-blend-mode: normal;
    border: 2px solid var(--new-green-color);
    box-sizing: border-box;
    border-radius: var(--space);
    padding: var(--space-quarter) var(--space) !important;
    color: var(--white-color);
    background-color: var(--new-green-color);
    /* margin-left: var(--space); */
}
.rounded-button.inverse:focus {
    background-color: var(--focused-rb-bg-color);
}
.rounded-button.inverse:hover {
    background-color: var(--hover-rb-bg-color);
}
.rounded-button.inverse:active {
    background-color: var(--active-rb-bg-color);
}
.rounded-button.inverse:disabled {
    color: var(--disabled-rb-font-color);
    border: 2px solid var(--primary-light-color);
    background-color: var(--disabled-rb-bg-color) !important;    
}

/* .rounded-button.inverse span{
    text-transform: capitalize;
} */
`, "",{"version":3,"sources":["webpack://./src/shared/components/rounded-button/RoundedButtonComponent.styles.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,sBAAsB;IACtB,8BAA8B;IAC9B,qDAAqD;IACrD,6BAA6B;IAC7B,+BAA+B;AACnC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,oCAAoC;IACpC,4CAA4C;IAC5C,wDAAwD;AAC5D;;AAEA;;GAEG;;AAEH;IACI,sBAAsB;IACtB,wCAAwC;IACxC,sBAAsB;IACtB,2BAA2B;IAC3B,qDAAqD;IACrD,yBAAyB;IACzB,wCAAwC;IACxC,+BAA+B;AACnC;AACA;IACI,4CAA4C;AAChD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,oCAAoC;IACpC,4CAA4C;IAC5C,wDAAwD;AAC5D;;AAEA;;GAEG","sourcesContent":["\n.rounded-button {\n    mix-blend-mode: normal;\n    border: 2px solid var(--new-green-color);\n    box-sizing: border-box;\n    border-radius: var(--space-x2);\n    padding: var(--space-quarter) var(--space) !important;\n    color: var(--new-green-color);\n    /* margin-left: var(--space); */\n}\n.rounded-button:focus {\n    background-color: var(--focused-rb-bg-color);\n}\n.rounded-button:hover {\n    background-color: var(--hover-rb-bg-color);\n}\n.rounded-button:active {\n    background-color: var(--active-rb-bg-color);\n}\n.rounded-button:disabled {\n    color: var(--disabled-rb-font-color);\n    border: 2px solid var(--primary-light-color);\n    background-color: var(--disabled-rb-bg-color) !important;    \n}\n\n/* .rounded-button span{\n    text-transform: capitalize;\n} */\n\n.rounded-button.inverse {\n    mix-blend-mode: normal;\n    border: 2px solid var(--new-green-color);\n    box-sizing: border-box;\n    border-radius: var(--space);\n    padding: var(--space-quarter) var(--space) !important;\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n    /* margin-left: var(--space); */\n}\n.rounded-button.inverse:focus {\n    background-color: var(--focused-rb-bg-color);\n}\n.rounded-button.inverse:hover {\n    background-color: var(--hover-rb-bg-color);\n}\n.rounded-button.inverse:active {\n    background-color: var(--active-rb-bg-color);\n}\n.rounded-button.inverse:disabled {\n    color: var(--disabled-rb-font-color);\n    border: 2px solid var(--primary-light-color);\n    background-color: var(--disabled-rb-bg-color) !important;    \n}\n\n/* .rounded-button.inverse span{\n    text-transform: capitalize;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
